import { MutationTree } from "vuex";

import { HomeState } from "./types";

export const mutations: MutationTree<HomeState> = {
  SET_RESUME_DATA_CACHE(state, { key, data }) {
    state.resumeDataCache = { ...state.resumeDataCache, [key]: data };
  },
  CLEAR_RESUME_DATA_CACHE(state) {
    state.resumeDataCache = {};
  }
};
